import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { en } from './i18n/en';
import { IframeMessageService } from './init-services/iframe-message.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class AppComponent implements OnInit {
  private readonly translateService = inject(TranslateService);
  private readonly iframeMessageService = inject(IframeMessageService);

  ngOnInit(): void {
    this.translateService.setTranslation('en', en);
    this.iframeMessageService.initialize();
  }
}
